import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DxTextBoxModule,
    DxFormModule,
    DxValidatorModule,
    DxSelectBoxComponent,
} from 'devextreme-angular';
import { getSizeQualifier } from 'src/app/services/screen.service';
import {
    AssignToUnloadAppointmentCommand,
    StagingLane,
    DataSources,
} from '@services';
import EnumUtils from 'src/app/shared/enum-utils';
import { PicturedItemSelectBoxComponent } from 'src/app/components/library/pictured-item-select-box/pictured-item-select-box.component';
import { StagingLanePipe } from 'src/app/pipes/staging-lane.pipe';
@Component({
    selector: 'assign-to-unload-form',
    templateUrl: './assign-to-unload-form.component.html',
    imports: [
        DxTextBoxModule,
        DxFormModule,
        DxValidatorModule,
        CommonModule,
        DxSelectBoxComponent,
        PicturedItemSelectBoxComponent,
    ],
    providers: [StagingLanePipe],
})
export class AssignToUnloadFormComponent {
    protected dataSources = inject(DataSources);
    private stagingLanePipe = inject(StagingLanePipe);
    
    data: AssignToUnloadAppointmentCommand = {} as AssignToUnloadAppointmentCommand;
    employeesDataSource = this.dataSources.employeeOptions();
    
    stagingLaneOptions = EnumUtils.getEnumOptions(StagingLane, (v) =>
        this.stagingLanePipe.transform(v),
    );

    getSizeQualifier = getSizeQualifier;

    async onEmployeeChange(employeeId: any) {
        this.data.employeeId = employeeId;
    }
    getData = () => new AssignToUnloadAppointmentCommand({ ...this.data });
}
